import { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { bodyFontFamily, headerFontFamily } from "styles/theme/mui";
import { homeHeaderTypography } from "../../styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: 16,
      direction: theme.direction,
    },

    statusCard: {
      height: 218,
      background: theme.palette.background.paper,
      borderRadius: 6,
      padding: 20,
      boxSizing: "border-box",
      overflow: "hidden",
    },

    statusContent: {
      height: "100%",
      display: "grid",
      gridTemplateColumns: "1fr 150px",
      alignItems: "start",
      gap: 16,
      direction: "ltr",
    },

    legend: {
      width: 285,
      height: 143,
      display: "flex",
      flexDirection: "column",
      gap: 12,
      justifySelf: "start",
      marginTop: 28,
      boxSizing: "border-box",
      direction: "ltr",
      opacity: 1,
    },

    legendRow: {
      width: "100%",
      display: "grid",
      gridTemplateColumns: "auto 1fr auto",
      alignItems: "center",
      columnGap: "7px",
    },

    legendValue: {
      fontSize: "16px !important",
      fontWeight: "400 !important",
      fontStyle: "normal",
      lineHeight: "120% !important",
      letterSpacing: "0 !important",
      verticalAlign: "middle",
      color: theme.palette.text.primary,
      fontFamily: headerFontFamily,
      textAlign: "left",
      gridColumn: "1",
    },

    legendLabel: {
      fontSize: "16px !important",
      fontWeight: "500 !important",
      fontStyle: "normal",
      lineHeight: "120% !important",
      letterSpacing: "0 !important",
      verticalAlign: "middle",
      color: theme.palette.secondary.main,
      fontFamily: bodyFontFamily,
      whiteSpace: "nowrap",
      textAlign: "right",
      direction: theme.direction,
      gridColumn: "2",
    },

    legendColor: {
      width: 14,
      height: 14,
      borderRadius: 4,
      gridColumn: "3",
    },

    chartSection: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      justifyContent: "space-between",
      justifySelf: "end",
      direction: "ltr",
    },

    title: {
      ...homeHeaderTypography,
      fontSize: "16px !important",
      fontWeight: "600 !important",
      lineHeight: "23.12px !important",
      color: theme.palette.secondary.main,
      marginBottom: "0 !important",
      whiteSpace: "nowrap",
      textAlign: "right",
    },

    donutChart: {
      width: 150,
      height: 150,
      borderRadius: "50%",
      background:
        "conic-gradient(#3498DB 0deg 175deg, #F39C12 175deg 255deg, #95A5A6 255deg 285deg, #9B59B6 285deg 320deg, #2ECC71 320deg 360deg)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      alignSelf: "flex-start",
    },

    donutInner: {
      width: 114,
      height: 114,
      borderRadius: "50%",
      background: theme.palette.background.paper,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
    },

    donutNumber: {
      fontSize: "26px !important",
      lineHeight: "28px !important",
      fontWeight: "800 !important",
      color: theme.palette.secondary.main,
      fontFamily: headerFontFamily,
    },

    donutText: {
      fontSize: "11px !important",
      color: theme.palette.text.primary,
      fontFamily: bodyFontFamily,
    },

    summaryGrid: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: 10,
    },

    summaryCard: {
      height: 101,
      background: theme.palette.background.paper,
      borderRadius: 6,
      padding: "20px 32px",
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexDirection: "row",
      gap: 10,
    },

    iconBox: {
      width: 28,
      height: 28,
      borderRadius: "50%",
      background: theme.palette.grey[400],
      color: theme.palette.text.disabled,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,

      "& svg": {
        fontSize: "17px !important",
      },
    },

    summaryTextBox: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      gap: 10,
    },

    cardValue: {
      fontSize: "26px !important",
      lineHeight: "28px !important",
      fontWeight: "800 !important",
      color: theme.palette.secondary.main,
      fontFamily: headerFontFamily,
      textAlign: "right",
    },

    cardLabel: {
      fontSize: "13.8px !important",
      fontWeight: "400 !important",
      fontStyle: "normal",
      lineHeight: "120% !important",
      letterSpacing: "0 !important",
      verticalAlign: "middle",
      color: theme.palette.text.primary,
      fontFamily: bodyFontFamily,
      textAlign: "center",
      whiteSpace: "nowrap",
    },
  })
);
